// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__28G8b","productName":"Table_productName__xGels"};